<template>
  <div class="card border-0 shadow-sm">
    <div class="card-header pb-0">
      <div class="d-flex align-items-center justify-content-between flex-wrap gap-2">
        <h6 class="mb-0">Recordatorios de Cambio de Aceite</h6>
        <input
          v-model="search"
          type="text"
          class="form-control form-control-sm"
          style="max-width: 220px;"
          placeholder="Buscar cliente, placa, moto..."
          @input="onSearch"
        />
      </div>
    </div>
    <div class="card-body">
      <div v-if="loading" class="text-center py-4">
        <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
      </div>
      <div v-else-if="data">
        <div class="row g-3 mb-3">
          <div class="col-6 col-md-3">
            <div class="text-center">
              <p class="text-xs text-secondary mb-0">Total</p>
              <h5 class="font-weight-bolder mb-0">{{ data.summary.total }}</h5>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="text-center">
              <p class="text-xs text-secondary mb-0">Vencidos</p>
              <h5 class="font-weight-bolder mb-0 text-danger">{{ data.summary.overdue }}</h5>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="text-center">
              <p class="text-xs text-secondary mb-0">Próximos</p>
              <h5 class="font-weight-bolder mb-0 text-warning">{{ data.summary.soon }}</h5>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="text-center">
              <p class="text-xs text-secondary mb-0">Al Día</p>
              <h5 class="font-weight-bolder mb-0 text-success">{{ data.summary.ok }}</h5>
            </div>
          </div>
        </div>

        <div class="table-responsive">
          <table class="table align-items-center mb-0">
            <thead>
              <tr>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cliente</th>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Moto</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Placa</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Último Servicio</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Días Transcurridos</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Estado</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in data.reminders" :key="idx">
                <td class="text-sm font-weight-bold">{{ item.customer_name || '—' }}</td>
                <td class="text-sm">{{ [item.motorcycle_brand, item.motorcycle_model].filter(Boolean).join(' ') || '—' }}</td>
                <td class="text-center text-sm">{{ item.license_plate || '—' }}</td>
                <td class="text-center text-sm">{{ formatDate(item.last_service_date) }}</td>
                <td class="text-center text-sm">{{ item.days_since_last !== null ? Math.round(item.days_since_last) + ' días' : '—' }}</td>
                <td class="text-center">
                  <span class="badge" :class="statusClass(item.status)">
                    {{ statusLabel(item.status) }}
                  </span>
                </td>
              </tr>
              <tr v-if="data.reminders.length === 0">
                <td colspan="6" class="text-center text-sm text-secondary py-3">No hay registros de cambios de aceite</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="d-flex align-items-center justify-content-between pt-2" v-if="data.pagination">
          <span class="text-xs text-secondary">
            {{ data.pagination.total }} registros · página {{ data.pagination.page }} de {{ data.pagination.last_page }}
          </span>
          <div class="btn-group btn-group-sm">
            <button class="btn btn-outline-primary mb-0" :disabled="data.pagination.page <= 1" @click="changePage(data.pagination.page - 1)">Anterior</button>
            <button class="btn btn-outline-primary mb-0" :disabled="data.pagination.page >= data.pagination.last_page" @click="changePage(data.pagination.page + 1)">Siguiente</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OilChangeReminders',
  data() {
    return {
      loading: false,
      data: null,
      search: '',
      page: 1,
      searchTimer: null,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      try {
        const response = await this.$store.dispatch('metrics/getOilChangeReminders', {
          search: this.search,
          page: this.page,
        });
        this.data = response.data;
      } catch (error) {
        console.error('Error loading oil change reminders:', error);
      } finally {
        this.loading = false;
      }
    },
    onSearch() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.page = 1;
        this.loadData();
      }, 400);
    },
    changePage(page) {
      this.page = page;
      this.loadData();
    },
    statusClass(status) {
      switch (status) {
        case 'overdue': return 'bg-danger';
        case 'soon': return 'bg-warning';
        case 'ok': return 'bg-success';
        default: return 'bg-secondary';
      }
    },
    statusLabel(status) {
      switch (status) {
        case 'overdue': return 'Vencido';
        case 'soon': return 'Próximo';
        case 'ok': return 'Al día';
        default: return 'Sin datos';
      }
    },
    formatDate(value) {
      if (!value) return '—';
      return new Date(value).toLocaleDateString('es-CO');
    },
  },
};
</script>
